export const GLOBAL_CALL_LISTENER_ENABLED =
    process.env.REACT_APP_GLOBAL_CALL_LISTENER !== 'false';
